<template>
  <div>
    <!-- <header class="header-navbar sticky-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="d-md-flex align-items-center justify-content-between">
              <div class="left-logo" style="width: 100%">
                <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header> -->
    <div
      class="p-wrapper-hld modal-dialog modal-content payment-popup"
      v-show="IsShowAlreadyPaidBox"
    >
      <div class="mt-5 text-center">
        <!-- To complete your payment, click on the button below -->
        <h3 class="text-capitalize">{{ customerName }}</h3>
        <h5>You have already registered and paid as below:</h5>
      </div>
      <div class="modal-header">
        <div
          class="d-flex justify-content-between align-items-center top-p-header"
        >
          <div class="left-side">
            <p>Amount</p>

            <h3>{{ ItemPrice }}</h3>
          </div>
          <div class="left-side">
            <p>Transaction Date</p>
            <h3>{{ transactionDate }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="p-wrapper-hld" v-show="IsShowPaymentBox">
      <div class="mt-5 text-center">
        <!-- To complete your payment, click on the button below -->
        <h3 class="text-capitalize">{{ customerName }}</h3>
        <h5>
          To complete the registration, please Click on the below button to Pay
        </h5>
      </div>
      <!---Payment modal start---->
      <!-- Modal -->
      <div
        id="payment-popup"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content payment-popup">
            <!---header start ---->
            <div class="modal-header">
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  top-p-header
                "
              >
                <div class="left-side">
                  <p>Paying To</p>
                  <!-- <h3>{{ clientName }}</h3> -->
                  <h3>{{ Payingto }}</h3>
                </div>
                <div class="right-side">
                  <img id="imgHostLogo" v-bind:src="hostLogo" alt="e2m" />
                </div>
              </div>
            </div>
            <!---header end ---->
            <div class="modal-body pt-4">
              <div class="p-plan-box total-p-price">
                <span
                  id="spntotalPrice"
                  class="p-plan-name"
                  style="width: 70%; padding-right: 15px; word-break: break-all"
                  >{{ productName }}</span
                >
                <span>{{ ItemPrice }}</span>
              </div>

              <div class="modal-footer text-center mt-4 paymentFooter">
                <stripe-checkout
                  ref="checkoutRef"
                  :pk="publishableKey"
                  :lineItems="lineItems"
                  :successUrl="successUrl"
                  :cancelUrl="cancelUrl"
                  :mode="mode"
                  :clientReferenceId="clientReferenceId"
                  :customerEmail="customerEmail"
                >
                  <template slot="checkout-button" style="width: 100%">
                    <button
                      id="btnStripePayment"
                      @click.prevent="checkout()"
                      class="reg-button text-uppercase mb-2"
                    >
                      Proceed To Pay
                    </button>
                  </template>
                </stripe-checkout>
                <span id="spnRedirectMessage"
                  >You will be redirected to Stripe for completing the
                  payment</span
                >
                <!-- <p>Visa and Master Cards Acepted</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---Payment modal end---->
    <!-- <div id="dvOtherMsg" class="classOtheMsg">
      This email is already registered, please sign-up with a different email.
    </div> -->
  </div>
</template>

<script>
//import Vue from "vue";
import db from "../components/firebaseInit";
import firebase from "firebase";
import axios from "axios";
import jQuery from "jquery";
let $ = jQuery;
//import db from "../components/firebaseInit";
import router from "../router";
import { StripeCheckout } from "vue-stripe-checkout";
import { bus } from "@/main";
import APIs from "@/components/APIInit";

var self;

export default {
  components: {
    StripeCheckout,
  },
  data() {
    return {
      IsShowPaymentBox: true,
      IsShowAlreadyPaidBox: false,
      transactionDate: "",
      customerName: "",
      hostLogo: "",
      ItemPrice: "$0",
      productName: "",
      email: "",

      /***********************STRIPE**************************************************** */
      Payingto: "E2M Live",
      PaymentStatus: "PENDING",
      PaymentSource: "STRIPE",
      enablePaymentPop: true,

      loading: false,
      //publishableKey: "pk_test_LFLCYOqCEVBQ9QxvpsgJEDfl", // live key:- "pk_live_yR0upxE0W5Xzq3lA0td0yxQ7",
      publishableKey:
        "pk_test_51HSEkxJy5CUjqeXa6XpfGrMFYzhhHq2wXnskSEBb8fqdmmjKnE8ZcB6i0VueYE9Y5SLObgqIiSdBxCvARZDRFCfD000UNXug3y", //LIVE
      lineItems: [
        {
          price: "",
          quantity: 1,
        },
      ],
      mode: "payment",
      successUrl: location.origin + "/regpaymentSuccess", //"/","https://ws.e2m.live",
      cancelUrl: location.origin + "/regpaymentFailure", //"https://bni.e2m.live",
      customerEmail: "",
      clientReferenceId: "",
      FormType: "Free",
      SubmitButtonText: "Complete Registration",
      /*************************************************************************** */
      BannerURL: "",
      clientID: "",
      evntId: "",
      eventName: "",
      clientName: "",
      hostName: "",
      eventcollectionname: "",
    };
  },
  async mounted() {
    self = this;
    //$("#topmenu").hide();
    //$("#leftmenu").hide();
    if (self.$route.params.e) {
      self.evntId = self.$route.params.e;
    }
    if (self.$route.params.eid) {
      self.email = self.$route.params.eid;
    }
    self.successUrl = location.origin + "/regpaymentSuccess/" + self.evntId;
    self.cancelUrl =
      location.origin + "/regpaymentFailure/" + self.evntId + "/" + self.email;
    // if (location.host.toLowerCase().indexOf("localhost") >= 0) {
    //   self.hostName = "uatbni.e2m.live";
    // } else {
    //   self.hostName = location.host;
    // }
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path = "";
    if (self.Environment() == "prd") {
      path = "https://resources.e2m.live/e2monair.appspot.com/";
    } else {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    }
    debugger;
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then(async (res) => {
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        self.clientLogo = res.data.LoginAssets.Logo;
        self.eventcollectionname = "OA_UAT_" + self.clientID + self.evntId;
        axios
          .get(
            APIs.EventBrandingJsonData +
              "?iid=OA_UAT" +
              "&cid=" +
              self.clientID +
              "&eid=" +
              self.evntId
          )
          .then(async (res) => {
            //var obj = new Object();

            // obj.EventFullName = res.data.result.EventInfo.EventFullName;
            // obj.TimeZone = res.data.result.EventInfo.TimeZone;
            // self.eventName = res.data.result.EventInfo.EventFullName;

            var eventBranding = {
              desktopBanner: res.data.result.EventInfo.EventBanner
                ? res.data.result.EventInfo.EventBanner
                : "",
              mobileBanner: res.data.result.EventInfo.EventBannerMobile
                ? res.data.result.EventInfo.EventBannerMobile
                : "",
              shareBanner: res.data.result.EventInfo.EventBannerShare
                ? res.data.result.EventInfo.EventBannerShare
                : "",
            };
            if (
              !eventBranding.desktopBanner ||
              !eventBranding.mobileBanner ||
              !eventBranding.shareBanner
            ) {
              if (res.data.result.banner) {
                if (
                  !eventBranding.desktopBanner &&
                  res.data.result.banner["2048x88"]
                ) {
                  eventBranding.desktopBanner =
                    res.data.result.banner["2048x88"];
                }
                if (
                  !eventBranding.mobileBanner &&
                  res.data.result.banner["750x103"]
                ) {
                  eventBranding.mobileBanner =
                    res.data.result.banner["750x103"];
                }
                if (
                  !eventBranding.shareBanner &&
                  res.data.result.banner["1200x628"]
                ) {
                  eventBranding.shareBanner =
                    res.data.result.banner["1200x628"];
                }
              }
            }
            if(self.evntId != self.getEventId()){
            bus.$emit("SetGuestBannerURL", eventBranding);
            }

            //self.getButtonBranding(self.hostName);
            self.getButtonBranding(self.hostName);
            self.setPopupPrice(self.email);
          })
          .catch((error) => {
            console.error(
              "There was an error to read event branding: " + error
            );
            //self.showSnackbar("There was an error to read event branding: " + error, "error", "top");
          });

        //   var brandingData;
        //   try {
        //     brandingData = await self.getBrandingJSONDetails(
        //       "OA_UAT_" + self.clientID + self.evntId + "/Branding/Branding.json"
        //     );
        //     if (brandingData.data != undefined) {
        //       this.item = brandingData.data;
        //       self.hostLogo = brandingData.data.HostInfo.Logo;
        //       if (brandingData.data.ClientInfo != undefined) {
        //         self.BannerURL =
        //           brandingData.data.ClientInfo.EventListAssets.banner2048x88;
        //       } else {
        //         self.BannerURL == "";
        //       }
        //       self.eventName = brandingData.data.EventInfo.EventFullName;
        //       document.title =
        //         brandingData.data.EventInfo.EventFullName +
        //         " - " +
        //         res.data.ClientName;
        //       var link = document.createElement("meta");
        //       link.setAttribute("property", "description");
        //       link.content = brandingData.data.EventInfo.Description;
        //       document.getElementsByTagName("head")[0].appendChild(link);

        //       self.ClientName = brandingData.data.HostInfo.Name;
        //       self.clientLogoUrl = brandingData.data.HostInfo.Logo;
        //       self.clientProfile = brandingData.data.HostInfo.Profile;

        //       // self.Payingto =
        //       //   response.data.Payingto != undefined ? response.data.Payingto : "";

        //       // self.hostLogo =
        //       //   response.data.PayingToLogo != undefined
        //       //     ? response.data.PayingToLogo
        //       //     : "";
        //       self.getButtonBranding(self.hostName);
        //       self.setPopupPrice(self.email);
        //     }
        //   } catch (e) {
        //     console.log("Error in Branding Json Fetch--", e);
        //     router.push({
        //       path: "/404",
        //     });
        //   }
      });
  },
  methods: {
    setPopupPrice: function (email) {
      var custName = "";
      var Custemail = "";
      var registrationTypeId = "";
      var registrationTypeName = "";
      var amount = "";
      var paymentStatus = "PENDING";
      var paymentDate = new Date();

      var postData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID.toString(),
          eventId: self.evntId,
        },
        data: {
          Email: email,
        },
      };
      //self.showLoader();
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.XAPIkey,
      };
      axios
        .post(APIs.CheckUserStatus, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          bus.$emit("toggleLoader", false);
          debugger;
          console.log(response);
          // response.data.result.Payment = {
          //   Amount: "$1.00",
          //   Created: "2022-11-02T08:57:14.991Z",
          //   Source: "STRIPE",
          //   Status: "PENDING",
          //   TransactionId: "",
          // };

          if (response.data.result.Name) {
            custName = response.data.result.Name;
            self.customerName = custName;
          }
          if (response.data.result.Email) {
            Custemail = response.data.result.Email;
          }
          if (response.data.result.RegistrationType) {
            if (response.data.result.RegistrationType.RegistrationTypeId) {
              registrationTypeId =
                response.data.result.RegistrationType.RegistrationTypeId;
            }
            if (response.data.result.RegistrationType.RegistrationType) {
              registrationTypeName =
                response.data.result.RegistrationType.RegistrationType;
            }
          }
          if (response.data.result.Payment) {
            if (response.data.result.Payment.Amount) {
              amount = response.data.result.Payment.Amount;
              if (amount.includes(".0")) {
                self.ItemPrice = amount;
              } else {
                self.ItemPrice = amount + ".00";
              }
            }
            if (response.data.result.Payment.Created) {
              paymentDate = response.data.result.Payment.Created;
              var dateFormat = require("dateformat");
              if (paymentDate.seconds) {
                self.transactionDate = dateFormat(
                  new Date(paymentDate.seconds * 1000),
                  "mmm dd, hh:MM TT"
                );
              } else if (paymentDate._seconds) {
                self.transactionDate = dateFormat(
                  new Date(paymentDate._seconds * 1000),
                  "mmm dd, hh:MM TT"
                );
              } else {
                self.transactionDate = dateFormat(
                  new Date(paymentDate),
                  "mmm dd, hh:MM TT"
                );
              }
            }
            if (response.data.result.Payment.Status) {
              paymentStatus = response.data.result.Payment.Status;
              if (paymentStatus.toLowerCase() == "paid") {
                self.IsShowPaymentBox = false;
                self.IsShowAlreadyPaidBox = true;
                return false;
              } else {
                self.IsShowPaymentBox = true;
                self.IsShowAlreadyPaidBox = false;
                self.productName = registrationTypeName;
                self.customerEmail = Custemail;

                self.getStaticFieldSettings(registrationTypeId);
              }
            }
          } else {
            self.showSnackbar(
              "No pending payment found for you!",
              "error",
              "top"
            );
            setTimeout(() => {
              router.push("/");
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    setPopupPrice1: function (eventcollectionname, attendeeID) {
      debugger;

      var listRef = db
        .collection(eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
        .doc("AttendeeList")
        .collection("Attendees")
        .where("AttendeeId", "==", attendeeID);
      var amount = "";
      var registrationType = "";
      var Custemail = "";
      var custName = "";
      var paymentStatus = "PENDING";
      var paymentDate = new Date();
      listRef
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            debugger;
            console.log(doc.data().Payment);

            amount = doc.data().Payment.Amount;

            registrationType = doc.data().RegistrationType;
            Custemail = doc.data().Email;
            custName = doc.data().Name;
            paymentStatus = doc.data().Payment.Status;
            paymentDate = doc.data().Payment.Created;
          });
          self.customerName = custName;
          self.productName = registrationType;
          var dateFormat = require("dateformat");
          self.transactionDate = dateFormat(
            new Date(paymentDate.seconds * 1000),
            "mmm dd, hh:MM TT"
          );

          if (amount.includes(".0")) {
            //  var decimalVal=amount.substring(indexOf(".")+1,2)
            self.ItemPrice = amount;
          } else {
            self.ItemPrice = amount + ".00";
          }
          if (paymentStatus == "PAID") {
            self.IsShowPaymentBox = false;
            self.IsShowAlreadyPaidBox = true;
            // document.getElementById("dvOtherMsg").innerText =
            //   "You have already paid.Please log in";
            // $("#Othermsg-modal").modal("show");
            // setTimeout(() => {
            //   router.push("/login");
            // }, 2000);
            return false;
          } else {
            self.IsShowPaymentBox = true;
            self.IsShowAlreadyPaidBox = false;
            self.productName = registrationType;
            self.customerEmail = Custemail;
            // self.customerName = custName;
            // if (amount.includes(".0")) {
            //   //  var decimalVal=amount.substring(indexOf(".")+1,2)
            //   self.ItemPrice = amount;
            // } else {
            //   self.ItemPrice = amount + ".00";
            // }
            self.getStaticFieldSettings1(registrationType, Custemail);
          }
        })
        .catch(function (error) {
          debugger;
          console.error("Error: ", error);
        });

      //var eventCol = "OA_UAT_" + clientID + evntId + "/AttendeeList/Attendees/" + attendeeID; //OA_UAT_C1591904892446E1591907102804///OA_UAT_C1591904892446E1591907102804/AttendeeList/Attendees/99900328

      /* var dropRegType = document.getElementById("dropRegType");
      var strRegtype = dropRegType.options[
        dropRegType.selectedIndex
      ].getAttribute("datatag");
      console.log(strRegtype);
      self.ItemPrice = strRegtype + ".00";
      self.productName = dropRegType.options[dropRegType.selectedIndex].text;*/
    },

    checkout() {
      debugger;
      console.log(self.publishableKey);
      console.log("successurl - " + self.successUrl);
      console.log("CancelUrl- " + self.succescancelUrlsUrl);

      /* var dropRegType = document.getElementById("dropRegType");
      var strRegtype = dropRegType.options[dropRegType.selectedIndex].value;
      if (strRegtype == "$0") {
        document.getElementById("dvOtherMsg").innerText =
          "Please select an option";
        $("#Othermsg-modal").modal("show");
        return false;
      } else {*/

      var spn = document.getElementById("spntotalPrice");
      spn.style.color = "red";

      document.getElementById("btnStripePayment").innerText =
        "Redirecting for Payment";

      var key = {
        instanceId: "OA_UAT",
        clientId: self.clientID.toString(),
        eventId: parseInt(self.evntId.replace("E", "")),
      };
      console.log(JSON.stringify(key));
      self.clientReferenceId = JSON.stringify(key);
      // var email = "suresh5@yopmail.com"; // document.getElementById("txtEmail").value;
      // self.customerEmail = email;
      // self.lineItems[0].price = strRegtype; // "price_1HTqmYHrUp03aSxsvpV5MQDx";
      setTimeout(() => {
        this.$refs.checkoutRef.redirectToCheckout();
      }, 2000);
      //}
    },
    getStaticFieldSettings: function (regTypeId) {
      debugger;
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/CheckoutForms.JSON"
      );
      objStaticFieldRef.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          console.log(
            "static Response Data:- " + JSON.stringify(response.data)
          );
          self.shortforCSSClass = "";
          self.publishableKey = "";
          if (self.Environment() == "prd") {
            if (response.data.Config.isTestModeEnabled == true) {
              if (response.data.Config.TestPublishableKey) {
                self.publishableKey = response.data.Config.TestPublishableKey;
              }
            } else {
              if (response.data.Config.LivePublishableKey) {
                self.publishableKey = response.data.Config.LivePublishableKey;
              }
            }
            //console.log("lk:- " + self.publishableKey);
          } else {
            if (response.data.Config.TestPublishableKey) {
              self.publishableKey = response.data.Config.TestPublishableKey;
            }
            //console.log("tk:- " + self.publishableKey);
          }
          if (response.data.FormType) {
            self.FormType = response.data.FormType;
          }
          for (
            var i = response.data.RegistrationTypes.length - 1;
            i >= 0;
            i--
          ) {
            if (
              response.data.RegistrationTypes[i].RegistrationTypeId == regTypeId
            ) {
              self.lineItems[0].price =
                response.data.RegistrationTypes[i].TicketPriceID;
            }
          }
          debugger;
          self.Payingto = response.data.Config.PayingTo
            ? response.data.Config.PayingTo
            : "";

          self.hostLogo =
            response.data.Config.PayingToLogo != undefined
              ? response.data.Config.PayingToLogo
              : "";
          self.SubmitButtonText = response.data.Config.SubmitButtonDisplayLabel;
        });
      });
    },
    getStaticFieldSettings1: function (productName) {
      debugger;
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/DefaultRegFormSettings.JSON"
      );

      objStaticFieldRef.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          console.log(
            "static Response Data:- " + JSON.stringify(response.data)
          );
          self.shortforCSSClass = "";

          //--------------------------------------------------------------------------
          debugger;
          if (self.hostName.toLowerCase().indexOf("uat") > -1) {
            self.publishableKey = response.data.TestPublishableKey;
            console.log("tk:- " + self.publishableKey);
          } else {
            self.publishableKey = response.data.LivePublishableKey;
            console.log("lk:- " + self.publishableKey);
          }
          //------------------------Payingto--------------------------------
          self.Payingto =
            response.data.Payingto != undefined ? response.data.Payingto : "";
          self.hostLogo =
            response.data.PayingToLogo != undefined
              ? response.data.PayingToLogo
              : "";
          //--------------------------------------------------------------------------
          self.FormType = response.data.FormType;
          debugger;
          for (
            var i = response.data.RegistrationType.RegTypes.length - 1;
            i >= 0;
            i--
          ) {
            if (
              response.data.RegistrationType.RegTypes[i].Name.toLowerCase() ==
              productName.toLowerCase()
            ) {
              self.lineItems[0].price =
                response.data.RegistrationType.RegTypes[i].TicketPriceID;
            }
          }

          //---------------------Submit Button Settings------------------------------------------------
          self.SubmitButtonText = response.data.SubmitButtonDisplayLabel;
          //-------------------------------------------------------------------------------------
        });
      });
    },
    getButtonBranding: function (hostName) {
      debugger;
      var path;
      if (hostName.toLowerCase().indexOf("uat") > -1) {
        path = "https://resources.e2m.live/uate2monair.appspot.com/";
      } else {
        path = "https://resources.e2m.live/e2monair.appspot.com/";
      }
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          debugger;
          self.clientLogo = res.data.LoginAssets.Logo;
          self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
          self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
          $("#btnRegister").css("background-color", self.btnBackColor);
          $("#btnRegister").css("color", self.btntextColor);

          $("#btnStripePayment").css("background-color", self.btnBackColor);
          $("#btnStripePayment").css("color", self.btntextColor);
        });
      //------------------------------------------------------------------------------
    },
  },
};
</script>